"use client";
import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { Icon as m } from "../icon/icon.js";
import { useState as x, useId as N } from "react";
import f from "clsx";
import { c as v, d as h } from "../../virginmediao2-momentum-icons-icons-fas-C-qJ8QLF.js";
import '../../assets/show-more.css';const o = {
  "show-more": "_show-more_19b3n_1",
  "show-more--trigger-position-center": "_show-more--trigger-position-center_19b3n_6",
  "show-more--trigger-position-center-sm": "_show-more--trigger-position-center-sm_19b3n_7",
  "show-more--trigger-position-end": "_show-more--trigger-position-end_19b3n_11",
  "show-more__trigger-container": "_show-more__trigger-container_19b3n_15",
  "show-more__trigger": "_show-more__trigger_19b3n_15",
  "show-more__title": "_show-more__title_19b3n_42",
  "show-more__indicator": "_show-more__indicator_19b3n_49",
  "show-more--expanded": "_show-more--expanded_19b3n_59",
  "show-more__content": "_show-more__content_19b3n_63",
  "show-more--expands-upwards": "_show-more--expands-upwards_19b3n_76",
  "show-more__icon": "_show-more__icon_19b3n_81",
  "show-more--horizontal-rule": "_show-more--horizontal-rule_19b3n_85"
}, $ = {
  arrowDown: h,
  arrowRight: v
}, D = ({
  title: c,
  titleExpanded: t,
  defaultExpanded: w = !1,
  expandsUpwards: d,
  horizontalRule: l,
  icon: i,
  renderWhenCollapsed: p,
  triggerPosition: n,
  children: g
}) => {
  const [s, b] = x(w), r = N(), u = f(o["show-more"], {
    [o["show-more--expanded"]]: s,
    [o["show-more--expands-upwards"]]: d,
    [o["show-more--horizontal-rule"]]: l,
    [o["show-more--trigger-position-start"]]: n === "start",
    [o["show-more--trigger-position-center"]]: n === "center",
    [o["show-more--trigger-position-center-sm"]]: n === "center-sm",
    [o["show-more--trigger-position-end"]]: n === "end"
  }), _ = i ? $[i] : null;
  return /* @__PURE__ */ a("div", { id: r, className: u, children: [
    /* @__PURE__ */ e("div", { className: o["show-more__trigger-container"], children: /* @__PURE__ */ a(
      "button",
      {
        type: "button",
        "data-testid": "show-more__trigger",
        className: o["show-more__trigger"],
        id: `${r}-trigger`,
        "aria-describedby": `${r}-title`,
        "aria-expanded": s,
        "aria-controls": `${r}-panel`,
        onClick: () => b(!s),
        children: [
          _ && /* @__PURE__ */ e("span", { className: o["show-more__icon"], children: /* @__PURE__ */ e(m, { icon: _, ratio: 0.75, size: "md" }) }),
          /* @__PURE__ */ e("span", { className: o["show-more__title"], id: `${r}-title`, children: s && t ? t : c }),
          /* @__PURE__ */ e("span", { className: o["show-more__indicator"], children: /* @__PURE__ */ e(m, { icon: h, ratio: 0.75, size: "md" }) })
        ]
      }
    ) }),
    /* @__PURE__ */ e(
      "div",
      {
        role: "region",
        className: o["show-more__panel"],
        id: `${r}-panel`,
        "aria-labelledby": `${r}-trigger`,
        "data-testid": "show-more__panel",
        children: (p || s) && /* @__PURE__ */ e("div", { className: o["show-more__content"], children: g })
      }
    )
  ] });
};
export {
  D as ShowMore
};
